export default function formatCouponExpiration(isoString: string): string {
  return new Date(isoString).toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'UTC',
    year: 'numeric'
  });
}
